/*
 * The rule for a winner's name, shared by the dialog and its tests.
 *
 * Any letter in any script (so every French accent, plus Œ/Æ), spaces, hyphens
 * and apostrophes — including the typographic apostrophe ’ a French keyboard
 * produces. A name may not open with a separator. The API enforces the same
 * rule; this copy exists to answer the typist instantly, not to be the gate.
 */
export const WINNER_NAME_RE = /^[\p{L}\p{M}][\p{L}\p{M} '’‘\-‐–]*$/u;
export const WINNER_NAME_MAX = 120;

/** The tidied name, or the reason it cannot be accepted. */
export function validateWinnerName(raw: string): { name: string } | { error: string } {
  const name = raw.replace(/\s+/g, ' ').trim();
  if (!name) return { error: 'Le nom est obligatoire.' };
  if (name.length > WINNER_NAME_MAX) return { error: `Le nom ne peut pas dépasser ${WINNER_NAME_MAX} caractères.` };
  if (!WINNER_NAME_RE.test(name)) {
    return { error: 'Le nom ne peut contenir que des lettres, des espaces, des traits d’union et des apostrophes.' };
  }
  return { name };
}
